import { Directive, ElementRef } from '@angular/core';
/**
 * @hidden
 */
var ListItemDirective = (function () {
    function ListItemDirective(element) {
        this.element = element;
    }
    return ListItemDirective;
}());
export { ListItemDirective };
ListItemDirective.decorators = [
    { type: Directive, args: [{
                selector: 'li' // tslint:disable-line
            },] },
];
/** @nocollapse */
ListItemDirective.ctorParameters = function () { return [
    { type: ElementRef, },
]; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-dropdowns/dist/es/list-item.directive.js
// module id = ../../../../@progress/kendo-angular-dropdowns/dist/es/list-item.directive.js
// module chunks = 3